import { emailValidator } from '../fields';

const config = { mandatory: true };

export default {
  to: {
    array: {
      email: emailValidator(config)
    }
  }
};
